import { useContext } from 'react';
import { SiteContentContext } from '../context/SiteContentContext';
import Icon from './Icon';

export const DEFAULT_DIFFICULTY_ICONS = ['lighthouse', 'lifebuoy', 'anchor', 'helm', 'yacht'];

const DifficultyIcons = ({ difficulty, sectionKey, size = 20 }) => {
  const { content } = useContext(SiteContentContext);
  if (!difficulty || difficulty <= 0) return null;

  const key = `${sectionKey}DifficultyIcons`;
  const stored = content[key];
  const icons = (Array.isArray(stored) && stored.length === 5) ? stored : DEFAULT_DIFFICULTY_ICONS;

  return (
    <span className="card-meta-difficulty">
      {icons.map((ic, i) => (
        <span key={i} style={{ filter: i < difficulty ? 'none' : 'grayscale(1) opacity(0.4)', display: 'inline-flex' }}>
          <Icon name={ic} size={size} color={i < difficulty ? '#db782e' : '#ccc'} />
        </span>
      ))}
    </span>
  );
};

export default DifficultyIcons;
